import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useCategorization = defineStore("categorization", () => {
  const opusData = ref(null);
  const dataQuery = ref(null);
  const statusData = ref(null);
  const statusQuery = ref(null);
  const isCategorizing = ref(false);
  const isImporting = ref(false);
  const hasSuggested = ref(false);

  //Management
  const selectedCategory = ref("");
  const hasSelectedCategory = computed(() => !!selectedCategory.value);

  const uncategorizedProducts = ref([]);

  //Auto-assign
  const isMatchUncategorized = ref(false);
  const isMatchExisting = ref(false);
  const moveFromSource = ref("");
  const isAutoAssigning = ref(false);

  async function getOpusData() {
    if (opusData.value == null) {
      const res = await dataQuery.value.executeQuery();
      if (res.data && res.data.value.slBrand.opusData) {
        opusData.value = res.data.value.slBrand.opusData;
      }
    }
  }

  return {
    opusData,
    dataQuery,
    statusData,
    statusQuery,
    isCategorizing,
    isImporting,
    hasSuggested,
    selectedCategory,
    hasSelectedCategory,
    uncategorizedProducts,
    isMatchUncategorized,
    isMatchExisting,
    moveFromSource,
    isAutoAssigning,
    getOpusData,
  };
});
